module.exports = __webpack_public_path__ + "img/yuannei.9d1f893c.png";